import { createAction } from '@reduxjs/toolkit';

export const natalieActions = {
  beforeJoinPage: {
    continueButton: {
      clicked: createAction<{ id: string }>('[Before Join Natalie Event Page] continue button clicked'),
    },
  },
  detailsPage: {
    startChattingButton: {
      clicked: createAction<{ id: string }>('[Natalie Event Details Page] start chatting button clicked'),
    },
  },
  joinPage: {
    joinButton: {
      clicked: createAction<{ id: string; isMicrophoneEnabled: boolean; microphoneId: string; speakerId: string }>(
        '[Join Natalie Event Page] join button clicked'
      ),
    },
  },
};
